"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const searchApprovals_1 = __importDefault(require("./searchApprovals"));
const sortApprovals_1 = __importDefault(require("./sortApprovals"));
const ApprovalsHeaderActions = () => {
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { "data-testid": "approvals-header-actions", style: {
            gap: theme.tsGoUnit.tsUnitTriple,
            padding: `${theme.tsGoUnit.tsUnit} ${theme.tsGoUnit.tsUnit} ${theme.tsGoUnit.tsUnitHalf}`,
        }, sx: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        }, children: [(0, jsx_runtime_1.jsx)(searchApprovals_1.default, {}), (0, jsx_runtime_1.jsx)(sortApprovals_1.default, {})] }));
};
exports.default = ApprovalsHeaderActions;
